import { render, staticRenderFns } from "./CrossEcology.vue?vue&type=template&id=4fe2f55f&scoped=true"
import script from "./CrossEcology.vue?vue&type=script&lang=js"
export * from "./CrossEcology.vue?vue&type=script&lang=js"
import style0 from "./CrossEcology.vue?vue&type=style&index=0&id=4fe2f55f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe2f55f",
  null
  
)

export default component.exports